export default "__VITE_ASSET__BDYzouUF__"